import type { ConfigRequest } from '@pba/react-utils';
import type { components } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type UsersParams = {
  limit?: number;
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Keys are defined by Backend API endpoint
  program_ids: string[];
  scope: 'programs';
  search?: string;
};

export const getProgramUsersAutocomplete = async ({ config }: ConfigRequest<UsersParams>) =>
  apiClient.get<Array<components['schemas']['UserList']>, ApiClientResponse<Array<components['schemas']['UserList']>>>(
    routes.program.autoComplete,
    config,
  );
